import React from "react";

function WidgetTemplate1(props) {
    return (
        <>
            <div className={"ml-2 mr-2 mb-4 " + props.name}>
                <div className={"t4-round-head t4-border-light t4-round-head-title g-font-mitr font-weight-bold"} style={{
                    fontFamily: "Arial, Mitr",
                    backgroundColor: "#FAFAFA"
                }}>
                    {props.title}
                </div>
                <div className={"t4-round-foot g-font-sarabun t4-border-light p-3"} style={{
                    backgroundColor: "#FAFAFA"
                }}>
                    {props.children}
                </div>
            </div>
        </>
    )
}

export default WidgetTemplate1;